@for (_ of [].constructor(numberOfReplies); track _; let i = $index) {
	@if (type === replyType.AddMultiple) {
		<add-multiple [placeholder]="'question.reply-text-placeholder' | translate"
			[emitNewValues]="true"
			[selectedItems]="multiLists[i]"
			(selectedItemsChange)="updateAddMultiple(i)" />
		@if (multiLists[i].length === 0) {
			<label>
				<input type="checkbox" [ngModel]="addMultipleReplies[i]?.length === 0" (ngModelChange)="addMultipleReplies[i] = $event ? [] : null" /> {{ 'question.none-selected' | translate }}
			</label>
		}
	}
	@else if (type === replyType.Select) {
		@if (selectList) {
			<custom-select
				[placeholder]="'question.reply-text-placeholder' | translate"
				[selectList]="selectList"
				[(value)]="replyView.replies[i]"
				(valueChange)="onUpdate.emit()" />
		}
	}
	@else if (type === replyType.TrueFalse) {
		<custom-input inputType="radio" [(value)]="replyView.replies[i]" (valueChange)="onUpdate.emit()">
			<radio-button [value]="false" [label]="'general.false' | translate" />
			<radio-button [value]="true" [label]="'general.true' | translate" />
		</custom-input>
	}
	@else {
		<custom-input
			[prefix]="displayIndex"
			[inputType]="inputType"
			[(value)]="stringReplies[i]"
			(valueChange)="onUpdate.emit()"
			[placeholder]="'question.reply-text-placeholder' | translate" />
	}
}
